/**
 * Created by Mattias on 2014-10-09.
 */
define('payment/handlers/sendHandlers/externalWindowHandler',['jquery', 'payment/externalPopupWindow', 'boxes/helpers/box-loading'],

    function($, externalPopupWindow, boxLoading) {
        'use strict';

        var methodName;
        var externalWindow;

        function init(methodNameIn) {
            methodName = methodNameIn;
            // Create popup window if we need it later, it has to be created before post otherwise stopped by popup blockers
            externalWindow = externalPopupWindow.getExternalWindow(methodName, 'providerPopupWindowEmpty');
        }

        function handleSuccessfulResponse(paymentBox, sendHandlerData, accHistRef, paymentFetchResultFlow) {
            var externalPopupWindowInformation = (sendHandlerData.externalUrl !== undefined ? sendHandlerData : sendHandlerData.handler);

            externalPopupWindow.redirectToProvider(externalWindow.document,
                                                   externalPopupWindowInformation.externalUrl,
                                                   externalPopupWindowInformation.externalParameters);

            externalPopupWindow.handleCloseAndPlayerRedirect(externalWindow,
                                                             paymentBox,
                                                             boxLoading,
                                                             externalPopupWindowInformation.asynchronousResult,
                                                             accHistRef,
                                                             paymentFetchResultFlow);
        }

        function cleanupOnFail() {
            externalWindow.close();
        }

        var externalWindowDepositSendHandler = {};
        externalWindowDepositSendHandler.init = init;
        externalWindowDepositSendHandler.handleSuccessfulResponse = handleSuccessfulResponse;
        externalWindowDepositSendHandler.cleanupOnFail = cleanupOnFail;

        return externalWindowDepositSendHandler;
    }
);

